import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavItem = ({
  href,
  faIcon,
  label,
  active,
  children,
  className,
  onClick,
}) => {
  return (
    <>
      <li className={active ? "nav-item active" : "nav-item"} onClick={onClick}>
        <a href={href} className={`nav-link ${className}`}>
          <FontAwesomeIcon icon={faIcon} fixedWidth />
          <span style={{ marginRight: "5px" }}>{label}</span>
        </a>
      </li>
    </>
  );
};

export default NavItem;
